import { render, staticRenderFns } from "./User-login-v3.vue?vue&type=template&id=af29cbe8&"
import script from "./User-login-v3.vue?vue&type=script&lang=js&"
export * from "./User-login-v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports